<template>
	<div
		class="modal"
		data-backdrop="static"
		id="showScopeModal"
		role="dialog"
		tabindex="-1"
		aria-labelledby="addCampaignGroup"
		aria-hidden="true"
	>
		<div class="modal-dialog modal-xl" role="document">
			<div class="modal-content campaign-g-addedit" style = "min-height:100px" >
				<div v-if="showLoader" class="spinner-border" style="margin:auto;display:block;"></div>
				<div v-else>
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLongTitle">Show Scope</h5>
						<button type="button"  class="close" data-dismiss="modal" @click = "toggleModal">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>

					<div v-if = "list.length == 0 && !allSelected" style ="justify-content:center;display: flex;margin:20px"><p>No Scope Defined</p></div>
					<div v-else-if = "allSelected" style ="justify-content:center;display: flex;margin:20px"><p>All Selected</p></div>
					<div class="modal-body" v-else>
						<div>
							<div>
								<div
									class="form-group row"
									v-for="(item,index) in list"
									:key="'prefilledActions_' + index"
								>
									<div class="col-md-2">
										<label for="name" class="col-md-12 col-form-label">{{item.type}} </label>
									</div>
									<div class="col-md-7 col-form-label">
										<p
											style=""

										>{{item.value}}</p>
									</div>
								</div>
							</div>
						</div>
					</div>


					<div class="modal-footer">
						<button class="btn btn-primary"  data-dismiss="modal"  @click = "toggleModal">Close</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Multiselect from "vue-multiselect";
	import CampaignFormDropDown from "@/components/add-campaign/CampaignFormDropDownNew";
	export default {
		name: "AddEditAutomation",
		components: {
			CampaignFormDropDown,
			Multiselect
		},
		props: ["automationId"],
		mounted() {
			if (this.automationId) {
				this.getScopeToShow();
			}
		},
		watch: {
			scopeList() {
				this.filterData();
			}
		},
		data() {
			return {
				list:[],
				conditionList: ["q", "s"],
				scopeList: [],
				showLoader: true,
				tempObj: {},
				mainObj: {},
				allSelected: false,
				filterDataList: {
					vendors: [],
					cgroup: [],
					all: [],
					profile: [],
					keyword: [],
					campaign: []
				}
			};
		},
		methods: {
			getScopeToShow() {
				var payload = {
					id: this.automationId
				};
				const vm = this;
				this.$store.dispatch("automation/showScopeData",payload).then(res => {
					if(res.length){
						vm.scopeList = res;
					}
					this.showLoader = false;
				});
			},
			toggleModal(){
				this.$emit('toggleModal')
			},
			filterData() {
				for (var i = 0; i < this.scopeList.length; i++) {
                    if((this.mainObj).hasOwnProperty(this.scopeList[i].automation_scope)){
						if(this.scopeList[i].automation_scope != 'all' ){
							if( JSON.parse(this.scopeList[i].scope_values).length>0){
							this.mainObj[this.scopeList[i].automation_scope].push(JSON.parse(this.scopeList[i].scope_values)[0].name)
							}
						}
						else{
							this.allSelected = true
						}
                    }
                    else{
                        this.mainObj[this.scopeList[i].automation_scope]=[] ;
						if(this.scopeList[i].automation_scope != 'all'){
							let arr = JSON.parse(this.scopeList[i].scope_values);
							for(let j = 0; j< arr.length; j++){

								this.mainObj[this.scopeList[i].automation_scope].push(arr[j].name)
							}
						}
						else{
							this.allSelected = true;
						}
                    }

					// if (scope[i].automation_scope == "vendors") {
					// 	this.filterDataList.vendors.push();
					// } else if (scope[i].automation_scope == "cgroup") {
					// 	this.filterDataList.cgroup.push();
					// } else if (scope[i].automation_scope == "all") {
					// 	this.filterDataList.all.push();
					// } else if (scope[i].automation_scope == "profile") {
					// 	this.filterDataList.profile.push();
					// } else if (scope[i].automation_scope == "keyword") {
					// 	this.filterDataList.keyword.push();
					// } else if (scope[i].automation_scope == "campaign") {
					// 	this.filterDataList.campaign.push();
					// }
                }
				let vm = this;
				Object.keys(this.mainObj).forEach((res,index) => {
					let keyVal ='';
					if(res == 'vendors'){
						keyVal = "Vendor"
					}
					else if(res == 'profile'){
						keyVal = "Profile"
					}
					else if(res == 'cgroup'){
						keyVal = "Campaign Group"
					}
					else if(res == 'campaign'){
						keyVal = "Campaign"
					}
					else if(res == 'keyword'){
						keyVal = "Keyword"
					}
					else if(res == 'all'){
						keyVal = "All"
					}
					vm.list.push({type:keyVal, value:vm.mainObj[res].join(',')})
				//	vm.list[index].value = vm.mainObj[res].join(',')
				})
               // console.log(mai)
			}
		}
	};
</script>
